export const urlParamKeys = {
  ga4Debug: 'ga4Debug', // debug ga4 events if `?ga4Debug=true`
  token: 'token',
  amazonCheckoutSessionId: 'amazonCheckoutSessionId',
  payment_intent_client_secret: 'payment_intent_client_secret',
  affStripe: 'aff-str',
  stripePhase2: 'aff-st2',
  affApplePay: 'aff-app',
  affXeroPromotion: 'aff-xero-promotion',
  affXeroAddOn: 'aff-xero-addon',
  affStripeScheduledDowngrade: 'aff-ssd',
  affSecureRedirect: 'aff-sec-rdr',
  affHidePromoCodes: 'aff-hpc',
  affAchMicroDeposits: 'aff-amd',
  planType: 'planType',
  emailPlanId: 'emailPlanId',
  paymentPeriod: 'paymentPeriod',
  nonprofit: 'nonprofit',
  currency: 'currency',
  contactCount: 'contactCount',
  promoCode: 'promoCode',
  promotionCd: 'promotionCd',
  addons: 'addons',
  returnurl: 'returnurl',
  returnURL: 'returnURL',
  returnUrl: 'returnUrl',
  returnLabel: 'returnLabel',
  affSmsBundle: 'aff-sms-bundle',
  googleSso: 'google_sso',
} as const;
